import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_vm.isMobile ? _c(VBtn, {
    class: `v-btn-x ml-1 mr-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "color": _vm.color,
      "title": _vm.title,
      "icon": "",
      "info": "",
      "fab": "",
      "text": ""
    },
    on: {
      "click": _vm.onUploadBtnClick
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.buttonIcon || 'fal fa-plus'))])], 1) : _c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "color": _vm.color,
      "text": "",
      "rounded": ""
    },
    on: {
      "click": _vm.onUploadBtnClick
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.buttonIcon || 'fal fa-plus'))]), _vm._v("\n     \n    " + _vm._s(_vm.title) + "\n  ")], 1), _vm.type == 'file' ? _c('input', {
    ref: "file",
    staticClass: "d-none",
    attrs: {
      "accept": _vm.accept,
      "type": "file",
      "name": "image"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };